const Yup = require("yup");

export const admissionGuidelinesSchema = Yup.object({
  title: Yup.string()
    .min(5, "Title must be at least 5 characters long") // Minimum length of 5 characters
    .max(100, "Title must be at most 100 characters long") // Maximum length of 100 characters
    .required("Title is required"),
  
  description: Yup.string()
    .min(10, "Description must be at least 10 characters long") // Minimum length of 20 characters
    .max(500, "Description must be at most 500 characters long") // Maximum length of 500 characters
    .required("Description is required"),
});



export const faqSchema = Yup.object({
  question: Yup.string().required("Question is required"),
  description: Yup.string().required("Description is required"),
});
